import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import App from './App'; // Admin Dashboard
import MerchantApp from './MerchantApp'; // Merchant Dashboard
import APIDocumentation from './pages/APIDocumentation'; // Standalone API Docs


const AppRouter = () => {
  return (
    <Router>
      <Routes>
        {/* Admin Dashboard Routes - Check first */}
        <Route path="/admin/*" element={<App />} />

        {/* Merchant Dashboard Routes */}
        <Route path="/merchant/*" element={<MerchantApp />} />

        {/* API Documentation via Backend - No Authentication Required */}
        <Route path="/api-documentation" element={
          <div style={{ height: '100vh', width: '100%' }}>
            <iframe
              src="/api/docs"
              style={{
                width: '100%',
                height: '100%',
                border: 'none',
                background: '#fff'
              }}
              title="API Documentation"
            />
          </div>
        } />

        {/* Redirect standalone api-documentation to admin version */}
        <Route path="/api-docs" element={<Navigate to="/admin/api-documentation" replace />} />

        {/* Legacy routes redirects */}
        <Route path="/dashboard" element={<Navigate to="/admin/dashboard" replace />} />
        <Route path="/transactions" element={<Navigate to="/admin/transactions" replace />} />
        <Route path="/cash-inout" element={<Navigate to="/admin/cash-inout" replace />} />
        <Route path="/settlements" element={<Navigate to="/admin/settlements" replace />} />
        <Route path="/payments" element={<Navigate to="/admin/payments" replace />} />
        <Route path="/payment-methods" element={<Navigate to="/admin/payment-methods" replace />} />
        <Route path="/analytics" element={<Navigate to="/admin/analytics" replace />} />
        <Route path="/users" element={<Navigate to="/admin/users" replace />} />
        <Route path="/members" element={<Navigate to="/admin/members" replace />} />
        <Route path="/reports" element={<Navigate to="/admin/reports" replace />} />
        <Route path="/security" element={<Navigate to="/admin/security" replace />} />
        <Route path="/settings" element={<Navigate to="/admin/settings" replace />} />
        <Route path="/config" element={<Navigate to="/admin/config" replace />} />
        <Route path="/master-products" element={<Navigate to="/admin/master-products" replace />} />
        <Route path="/fee-tiers" element={<Navigate to="/admin/fee-tiers" replace />} />
        <Route path="/merchant-finance" element={<Navigate to="/merchant/finance" replace />} />
        <Route path="/cash-in" element={<Navigate to="/merchant/cash-in" replace />} />
        <Route path="/qris-merchants" element={<Navigate to="/admin/qris-merchants" replace />} />
        <Route path="/qris-payment" element={<Navigate to="/admin/qris-payment" replace />} />
        <Route path="/merchant-approval" element={<Navigate to="/admin/merchant-approval" replace />} />
        <Route path="/tps-testing" element={<Navigate to="/admin/tps-testing" replace />} />
        <Route path="/supplier-management" element={<Navigate to="/admin/supplier-management" replace />} />
        <Route path="/category-management" element={<Navigate to="/admin/category-management" replace />} />

        {/* Default redirect to merchant dashboard (will handle auth internally) */}
        <Route path="/" element={<Navigate to="/merchant/dashboard" replace />} />
      </Routes>
    </Router>
  );
};

export default AppRouter;